import { useInitialization } from 'components/InitializationProvider';
import { useMenuSelection } from 'global/MenuSelectionContext';
import { logger } from 'utils/logger';

const RequireMenuInitialized = ({ children }: { children: React.ReactNode }) => {
  const { isInitialized } = useMenuSelection();
  const { shouldShowLoader } = useInitialization();

  logger.debug('[RequireMenuInitialized] Estado atual:', {
    isInitialized,
    shouldShowLoader,
  });

  // If initialization loader should be shown, don't render anything
  // REMOVED: Don't block rendering during loading
  // if (shouldShowLoader) {
  //   logger.debug('[RequireMenuInitialized] Showing centralized loader');
  //   return null;
  // }

  if (!isInitialized) {
    logger.debug('[RequireMenuInitialized] Menu not initialized, waiting...');
    return null; // The centralized loader is already showing progress
  }

  logger.debug('[RequireMenuInitialized] ✅ Rendering children');
  return <>{children}</>;
};

export default RequireMenuInitialized;
